<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title">
      {{ 'OPEN_CASH_DRAWER.SELECT_ACTION_TO_OPEN_DRAWER' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>

  <hr class="hr-line"/>
  <div class="dialog-form">
    <div class="form-container form-body-margin-btm">
      <div class="grid-row">
        <div
          class="order-card"
          *ngFor="let item of drawerActions"
          (click)="
            isRetryApplicable(item) ? getAllCashStats() : cardClicked(item)
          "
        >
          <img
            width="50px;"
            height="auto"
            class="order-type-img"
            [src]="images.CASH_REGISTER_URL + item.img"
            [alt]="item.name"
          />
          <!-- we have to change url here later -->
          <ng-container
            *ngIf="
              item?.id === 'open-cashier' || item?.id === 'close-cashier';
              else otherActions
            "
          >
            <ng-container *ngIf="!retryEnabled; else retry">
              <p *ngIf="!loading" class="order-type-text">{{ item?.name }}</p>
              <nz-skeleton
                [nzLoading]="loading"
                [nzTitle]="false"
                [nzActive]="true"
                [nzParagraph]="{ rows: 1, width: '45%' }"
              ></nz-skeleton>
            </ng-container>
            <ng-template #retry>
              <div class="retry-overlay flex-center flex_column">
                <i
                  nz-icon
                  [nzType]="'sync'"
                  [nzSpin]="loading"
                  class="fs-26 fw-600"
                ></i>
                <p nz-text>{{ 'OPEN_CASH_DRAWER.RETRY' | fallbackTranslate }}</p>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #otherActions>
            <p class="order-type-text">{{ item?.name }}</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
